module.exports = __webpack_public_path__ + "media/landing_video.84f52622.mp4";